const varDoiTypes = {
  'journal-article': 'article-journal',
  'book-chapter': 'chapter',
  'posted-content': 'manuscript',
  'proceedings-article': 'paper-conference'
};

const fetchDoiType = value => varDoiTypes[value] || value;

export { fetchDoiType as parse, fetchDoiType as default };